import { useContext, useEffect, useState } from "react";
import { Avatar, Box, Button, Menu, Typography } from "@mui/material";
import AdminMenu from "../AdminMenu";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LogoutIcon from "@mui/icons-material/Logout";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { GlobalContext } from "../Context";
import { useTranslation } from "react-i18next";
import { purple, white } from "../../../theme/colours";
import UserMenuItem from "./UserMenuItem";

const UserAvatarButton = ({
  handleLogout,
  isAdmin,
  isMedidas,
  name,
  avatar,
}) => {
  const { t } = useTranslation("Navigation");
  const {
    companyState,
    userState,
    currentUser,
    setUserStateEmail,
    desktopView,
    tabletView,
    mobileView,
  } = useContext(GlobalContext);

  const containerStyle = { height: "100%" };
  const buttonStyle = {
    width: "fit-content",
    height: "100%",
    alignSelf: "flex-end",
    p: mobileView ? "0 1rem" : "0 2rem",
    color: "#EAEAEA",
    ...(tabletView && {
      alignItems: "flex-end",
      pb: "1rem",
    }),
  };
  const userIconStyle = {
    width: "2.8rem",
    height: "2.8rem",
    borderRadius: "50%",
    background: white,
  };
  const contentsBox = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "inherit",
    "& svg": {
      color: white,
      m: desktopView
        ? "0 1.5rem"
        : tabletView
        ? "0 2rem 0 0.5rem"
        : "0 0 0 0.5rem",
      fontSize: mobileView && "1.25rem",
    },
  };
  const buttonText = {
    color: white,
    fontSize: mobileView && "1rem",
  };
  const menuStyle = {
    maxWidth: "17rem",
    right: 0,
    transform: "translate(1rem, 0)",
    "& .MuiMenu-paper": {
      maxWidth: "17rem",
      minWidth: "17rem",
      backgroundColor: purple[1],
      top: tabletView ? "6rem" : "4.5rem",
      borderRadius: 0,
    },
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [source, setSource] = useState("");

  const isOpen = Boolean(anchorEl);
  const openIcon = isOpen ? <ExpandLess /> : <ExpandMore />;

  useEffect(() => {
    if (userState.isMedidas && companyState?.iconURL) {
      setSource(companyState.iconURL);
    } else if (avatar) {
      const typeNumber = Math.max(parseInt(avatar.substring(4)), 12);
      setSource(`images/avatars/type${typeNumber || "12"}.svg`);
    }
  }, [avatar, companyState, userState.isMedidas]);

  const handleClick = (e) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStopImpersonating = () => {
    setUserStateEmail(null);
  };

  return (
    <Box sx={containerStyle}>
      <Button sx={buttonStyle} id="UserMenuItem" onClick={handleClick}>
        <Box sx={contentsBox}>
          <Typography sx={buttonText} variant="h2">
            {name}
          </Typography>
          {openIcon}
          {!mobileView && <Avatar sx={userIconStyle} src={source} alt="USER" />}
        </Box>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        timeout="auto"
        unmountOnExit
        sx={menuStyle}>
        {currentUser !== userState && (
          <UserMenuItem
            text={t("stopImpersonating")}
            icon={<LogoutIcon />}
            onClick={handleStopImpersonating}
          />
        )}
        {isAdmin && <AdminMenu isMedidas={isMedidas} />}
        <UserMenuItem
          text={t("tAndC")}
          onClick={() =>
            (window.location.href =
              "https://saferoadschallenge.com/terms-of-use/")
          }
        />
        <UserMenuItem
          text={t("privacyPolicy")}
          onClick={() =>
            (window.location.href =
              "https://saferoadschallenge.com/privacy-policy/")
          }
        />
        <UserMenuItem
          text={t("logOut")}
          icon={<ExitToAppIcon />}
          onClick={handleLogout}
        />
      </Menu>
    </Box>
  );
};

export default UserAvatarButton;
